import { showLoading, hideLoading } from 'react-redux-loading-bar'
import AdoptionActions from './actions'
import { addNotification as notify } from 'reapop'
import request from './../../utils/requestConfig'
import {paramsWarningNotify} from '../../utils/notifyConfig'
import moment from 'moment'

export default class AdoptionMiddleware {
  static fetchAllAdoption () {
    return (dispatch) => {
      dispatch(this.fetchAdoptions())
      dispatch(this.fetchAdoptionDueDate())
      dispatch(this.fetchAdoptionsCounterAdopted())
      dispatch(this.fetchAdoptionsCounterPending())
      dispatch(this.fetchAdoptionsProductDetail())
    }
  }
  static fetchAdoptions () {
    return (dispatch, getState) => {
      const {
        filterGradeId,
        filter,
        paginate
      } = getState().adoption
      const { currentItem } = getState().units

      dispatch(AdoptionActions.fetchAdoptionsRequest())
      request.get('/school_adoptions/search', {
        params: {
          per: paginate.perPage,
          page: paginate.page,
          education_grade_ids: filterGradeId,
          school_unit_ids: currentItem.item != null ? currentItem.item.value : 0,
          has_curriculum: true,
          order_by: 'school_curriculum_id',
          education_subject_ids: filter.subjects.toString(),
          user_user_ids: filter.teachers.toString(),
          statuses: filter.status.toString(),
          education_intelligence_scope_ids: filter.intelligenceScopes.toString(),
          education_onu_group_ids: filter.onuGroups.toString(),
          education_onu_goal_ids: filter.onuGoals.toString(),
          education_twentyfirst_competence_ids: filter.twentyfirstCompetences.toString(),
          education_twentyfirst_skill_ids: filter.twentyfirstSkills.toString(),
          education_oost_subject_ids: filter.oostSubjects.toString(),
          education_sel_ids: filter.sels.toString()
        }
      })
        .then(({ data, headers }) => {
          dispatch(AdoptionActions.fetchAdoptionsSuccess({ data, totalCount: headers['x-total-count'] || 0 }))
          dispatch(hideLoading())
        })
        .catch((error) => {
          dispatch(AdoptionActions.fetchAdoptionsError(), '')
          dispatch(hideLoading())
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar adoções!',
            status: error.response.status
          }))
        })
    }
  }
  // this is unused
  static fetchAdoptionsProductDetail () {
    return (dispatch, getState) => {
      const { paginate } = getState().adoption.stationery
      const { currentItem } = getState().units
      const { filterGradeId } = getState().adoption

      dispatch(AdoptionActions.fetchStationeryRequest())
      request.get('/school_adoptions/search', {
        params: {
          per: paginate.perPage,
          page: paginate.page,
          education_grade_ids: filterGradeId,
          school_unit_ids: currentItem.item != null ? currentItem.item.value : 0,
          has_curriculum: false,
          order_by: 'school_curriculum_id'
        }
      })
        .then(({ data, headers }) => {
          dispatch(AdoptionActions.fetchStationerySuccess({ data, totalCount: headers['x-total-count'] || 0 }))
          dispatch(hideLoading())
        })
        .catch((error) => {
          dispatch(AdoptionActions.fetchStationeryError(), '')
          dispatch(hideLoading())
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar detalhes dos itens!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchAdoptionsSend (status, hasCurriculum) {
    return (dispatch, getState) => {
      const { currentItem } = getState().units

      dispatch(AdoptionActions.fetchAdoptionsSendRequest())
      return request.get('/school_adoptions/search', {
        params: {
          per: 10000,
          page: 1,
          statuses: status,
          school_unit_ids: currentItem.item != null ? currentItem.item.value : 0,
          has_curriculum: hasCurriculum,
          order_by: 'school_curriculum_id'
        }
      })
        .then(({data}) => {
          dispatch(AdoptionActions.fetchAdoptionsSendSuccess({data}))
        })
        .catch((error) => {
          dispatch(AdoptionActions.fetchAdoptionsSendError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar adoções enviadas!',
            status: error.response.status
          }))
        })
    }
  }

  static fetchSegments () {
    return (dispatch, getState) => {
      dispatch(showLoading())
      dispatch(AdoptionActions.fetchSegmentsRequest())
      request.get('/grades')
        .then(({ data }) => {
          const grades = data.data
          dispatch(AdoptionActions.addGrades(grades))
          if (getState().adoption.filterGradeId === 0) {
            dispatch(AdoptionActions.setFilterGradeId(grades[0].id))
          }
          dispatch(this.fetchAdoptions())
        })
        .catch((error) => {
          console.log(error)
          dispatch(AdoptionActions.fetchSegmentsError(), '')
          dispatch(hideLoading())
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar segmentos educacionais!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchAdoptionsCounterAdopted () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      dispatch(AdoptionActions.fetchAdoptionsCounterAdoptedRequest())
      request.get('/school_adoptions/total_by_status', {
        params: {
          school_unit_id: currentItem.item != null ? currentItem.item.value : 0,
          statuses: 'approved_coordinator'
        }
      })
        .then(({data}) => {
          dispatch(AdoptionActions.fetchAdoptionsCounterAdoptedSuccess(data))
        })
        .catch((error) => {
          dispatch(AdoptionActions.fetchAdoptionsCounterAdoptedError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar o total de adoções!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchAdoptionsCounterPending () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units

      dispatch(AdoptionActions.fetchAdoptionsCounterPendingRequest())
      request.get('/school_adoptions/total_by_status', {
        params: {
          school_unit_id: currentItem.item != null ? currentItem.item.value : 0,
          statuses: 'pending'
        }
      })
        .then(({data}) => {
          dispatch(AdoptionActions.fetchAdoptionsCounterPendingSuccess(data))
        })
        .catch((error) => {
          dispatch(AdoptionActions.fetchAdoptionsCounterPendingError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar o total de adoções pendentes!',
            status: error.response.status
          }))
        })
    }
  }

  static postAdoptionSend () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      request.post('/school_adoptions/send_all_approved_director', {
        school_unit_id: currentItem.item != null ? currentItem.item.value : 0
      })
        .then(({ status }) => {
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Os livros foram enviados com sucesso!',
            status: status
          }))
          dispatch(AdoptionMiddleware.fetchAdoptions())
          dispatch(AdoptionActions.triggerFetchAdoptionsToBeSent())
          dispatch(AdoptionMiddleware.fetchAdoptionsProductDetail())
        })
        .catch((error) => {
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível enviar os livros!',
            status: error.response.status
          }))
        })
    }
  }
  static postAdoptionApprove () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      request.post('/school_adoptions/approve', {
        school_unit_id: currentItem.item != null ? currentItem.item.value : 0
      })
        .then(({ status }) => {
          dispatch(this.fetchAllAdoption())
          dispatch(AdoptionActions.triggerFetchAdoptionsToBeSent())
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Lista finalizada com sucesso!',
            status: status
          }))
        })
        .catch((error) => {
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível finalizar a lista!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchAdoptionDueDate () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      dispatch(AdoptionActions.fetchAdoptionDueDateRequest())
      request.get('/adoption_due_dates', {
        params: {
          school_unit_id: currentItem.item != null ? currentItem.item.value : 0
        }
      })
        .then(({data}) => {
          dispatch(AdoptionActions.fetchAdoptionDueDateSuccess(data[0].due))
        })
        .catch((error) => {
          dispatch(AdoptionActions.fetchAdoptionDueDateError(), '')
          if (error.response) {
            dispatch(notify({
              ...paramsWarningNotify,
              message: 'Não foi possível carregar o prazo da adoção!',
              status: error.response.status
            }))
          }
        })
    }
  }

  static changeAdoptionDueDate ({ date }) {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      dispatch(AdoptionActions.changeAdoptionDueDateRequest())
      request.post('/adoption_due_dates', {
        school_unit_id: currentItem.item != null ? currentItem.item.value : 0,
        due: date
      })
        .then(({ data, status, headers }) => {
          dispatch(AdoptionActions.changeAdoptionDueDateSuccess(data.due))
          dispatch(notify({
            ...paramsWarningNotify,
            message: `O prazo foi alterado para ${moment(data.due).endOf('day').calendar()}`,
            status: status
          }))
        })
        .catch((error) => {
          dispatch(AdoptionActions.changeAdoptionDueDateError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Erro ao alterar o prazo!',
            status: error.response.status
          }))
        })
    }
  }

  static removeAdoption (id) {
    return (dispatch) => {
      dispatch(AdoptionActions.deleteAdoptionRequest())
      request.delete(`/school_adoptions/${id}`)
      .then(res => {
        dispatch(AdoptionMiddleware.fetchAdoptions())
        dispatch(notify({
          ...paramsWarningNotify,
          message: 'Item removido da lista de adoção',
          status: 200
        }))
      })
      .catch(({data, status}) => {
        dispatch(AdoptionActions.deleteAdoptionsError(data))
        dispatch(notify({
          ...paramsWarningNotify,
          message: 'Não foi possível apagar adoção',
          status: status
        }))
      })
    }
  }

  static changeAdoptionStatus ({ id, status, quantity }) {
    return (dispatch) => {
      const goodMessage = status ? 'Status alterado com sucesso.' : 'Quantidade alterada com sucesso.'
      const badMessage = status ? 'Não foi possível alterar o status.' : 'Não foi possível alterar a quantitd'
      dispatch(AdoptionActions.changeAdoptionStatusRequest())
      request.put(`/school_adoptions/${id}`, {
        status,
        quantity
      })
        .then(({data, status}) => {
          dispatch(AdoptionActions.changeAdoptionStatusSuccess())
          dispatch(AdoptionActions.triggerFetchAdoptionsToBeSent())
          dispatch(this.fetchAllAdoption())
          dispatch(notify({
            ...paramsWarningNotify,
            message: goodMessage,
            status: status
          }))
        })
        .catch((error) => {
          dispatch(AdoptionActions.changeAdoptionStatusError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: badMessage,
            status: error.response.status
          }))
        })
    }
  }
  static addNewAdoptionItem ({gradeId, subjectId, bookId, productId, quantity}) {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      let status = 'approved_director'
      if (currentItem.item === null) {
        dispatch(notify({
          ...paramsWarningNotify,
          message: 'Por favor selecione uma Escola',
          status: 500
        }))
        return
      }
      const params = {
        status,
        education_grade_id: gradeId,
        school_unit_id: currentItem.item != null ? currentItem.item.value : 0
      }
      if (subjectId) {
        // params['user_user_id'] = authUser.id
        params['education_subject_id'] = subjectId
        params['book_book_id'] = bookId
      }
      if (productId) {
        params['crm_product_id'] = productId
        params['quantity'] = quantity
      }
      request.post(`/school_adoptions${productId ? '/products' : '/books'}`, params)
        .then(({data, status}) => {
          dispatch(notify({
            title: 'Sucesso',
            message: 'Item adicionado com sucesso à Lista de Adoções',
            status: 'success'
          }))
        })
        .catch((error) => {
          if (error.response) {
            dispatch(notify({
              ...paramsWarningNotify,
              message: 'Este item já foi adicionado à lista',
              status: error.response.status
            }))
          }
        })
    }
  }

  // modals
  static dialogAdoptionToggleView () {
    return (dispatch) => {
      dispatch(AdoptionActions.DialogToggleView())
    }
  }
  static dialogAdoptionChangeItem (newItem) {
    return (dispatch) => {
      dispatch(AdoptionActions.DialogChangeItem(newItem))
    }
  }
  static modalAdoptionsToggleView () {
    return (dispatch) => {
      dispatch(AdoptionActions.ModalToggleView())
    }
  }

  // paginate
  static changePageAdoption (page) {
    return (dispatch) => {
      dispatch(hideLoading())
      dispatch(showLoading())
      dispatch(AdoptionActions.changePageAdotion(page))
      dispatch(AdoptionMiddleware.fetchAdoptions())
    }
  }

  static triggerFetchAdoptionsToBeSent () {
    return (dispatch) => {
      dispatch(AdoptionActions.triggerFetchAdoptionsToBeSent())
    }
  }
  static changeAdvancedFilter (type, activeIds) {
    return (dispatch) => {
      dispatch(AdoptionActions.changeAdvancedFilter({type, activeIds}))
      dispatch(AdoptionMiddleware.fetchAdoptions())
    }
  }
  static changeFilter (type, activeIds) {
    return (dispatch) => {
      dispatch(AdoptionActions.changeFilter({type, activeIds}))
      dispatch(AdoptionMiddleware.fetchAdoptions())
    }
  }

  static resetFilter () {
    return (dispatch) => {
      dispatch(AdoptionActions.resetAdoptionFilter())
      dispatch(AdoptionMiddleware.fetchAdoptions())
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/adoption/middleware.js